/**
 * Where the web API is, as the browser reaches it: this same origin under `sst dev`, where Vite
 * proxies `/api` to the function running on the developer's machine, and the web API's own host on
 * a deployed stage. Trailing slash removed, so callers can append a path without doubling it.
 */
export function resolveApiBase(configured: string | undefined, origin: string) {
  return new URL(configured || "/api", origin).toString().replace(/\/$/, "")
}

/**
 * Where the sign-in routes are. Better Auth's client ignores its `basePath` when the base URL it is
 * given already carries a path, so it is handed the whole path and never the two halves.
 */
export function signInBaseUrl(apiBase: string) {
  return `${apiBase}/auth`
}

/**
 * The path to come back to after signing in, when it is one of this web app's own: a path from its
 * root, with any search and hash. Anything that could leave the origin — a whole URL, a
 * protocol-relative `//host`, a backslash a browser reads as a slash, a control character — is
 * nothing, and sign-in returns to the root instead. `next` comes from the address bar, so it is
 * never trusted as it stands.
 */
export function sameOriginPath(next: string | null | undefined, origin: string) {
  if (!next || !next.startsWith("/") || next.startsWith("//")) return undefined
  if (/[\\\u0000-\u001f\u007f]/.test(next)) return undefined
  try {
    const url = new URL(next, origin)
    return url.origin === new URL(origin).origin
      ? `${url.pathname}${url.search}${url.hash}`
      : undefined
  } catch {
    return undefined
  }
}
